//
//
//
//
//
//

export default {
  name: "Tihuo"
}



// WEBPACK FOOTER //
// ./src/components/uc/Tihuo.vue